import { List, Map } from 'immutable'
import { combineReducers } from 'redux'
import * as actions from './modalActions'

function queue(state = List(), action) {
  switch (action.type) {
    case actions.ADD_MODAL:
      return state.push(Map({
        id: action.modalId,
        data: action.modalData,
      }))

    case actions.REMOVE_MODAL:
      return state.filter(modal => modal.get('id') !== action.modalId)

    default:
      return state
  }
}

export default combineReducers({
  queue,
})
